import getters from '@/store/modules/instantSearch/getters'
import actions from '@/store/modules/instantSearch/actions'
import mutations from '@/store/modules/instantSearch/mutations'

export default {
  namespaced: true,
  state() {
    return {
      searchValue: '',
      opened: false
    }
  },
  getters,
  actions,
  mutations
}
